import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { v4 } from 'uuid';
import { getCookie } from '@app/utils';
import { getDealerSOSDetails } from '@app/store/checkout/actions';
import { SIS_CART_PARTS_LIST } from '@app/constants/cookieContants';
import {
  FORMIK_INITAL_VALUES,
  REQUEST_BY_DATE_VALUE,
  EQUIPMENT_VALUE
} from '../../shopping-cart/ShoppingCartPage/constants';
import { useTranslation } from 'react-i18next';

const useSisCartCookie = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const getItemsSisCartCookie = useCallback(() => {
    const cookie = getCookie(SIS_CART_PARTS_LIST) || '';
    if (cookie) {
      const cookieValue = decodeURIComponent(cookie);
      const rows = cookieValue.split(',');
      const items = rows.reduce(
        (acc, row, index) => {
          const values = (row || '').split(':');
          acc[index] = {
            quantity: values[1] || '',
            itemNumber: values[0] || '',
            assetId: values[2] || '',
            lineItemNote: values[3] || '',
            customerPartNumber: values[4] || '',
            customerItemNumber: values[5] || '',
            id: v4()
          };
          return acc;
        },
        [...FORMIK_INITAL_VALUES.items]
      );
      if (items.length > 0) {
        dispatch(
          getDealerSOSDetails({
            items,
            sisFlow: true,
            t
          })
        );
      }
      sessionStorage.removeItem(EQUIPMENT_VALUE);
      sessionStorage.removeItem(REQUEST_BY_DATE_VALUE);
    }
  }, [dispatch, t]);
  return {
    getItemsSisCartCookie
  };
};

export default useSisCartCookie;
